import logo from "../Assets/logo.png"
import {Col, Row, Typography} from "antd";
export const Credits = () => {
  return(
    <>
      <div className="div-primary-color p-20">
        <div className="container">
          <Row>
            <Col>
              <div style={{ float: 'left', marginRight: '10px' }}>
                <img width={200} src={logo} alt="HBKU Logo" />
              </div>
              <Typography.Title>COVID-19Base 3.0</Typography.Title>
              <p>
                COVID-19Base is the first comprehensive knowledgebase to find the association of seven different thematic areas related to COVID-19/SARS-CoV-2 and other coronavirus-related diseases in humans. While careful manual curation of the identified associations is the ultimate goal, in COVID-19Base, we implement a novel approach to estimate the effectiveness of drug for diseases based on natural language processing, sentiment analysis, and deep learning. We also apply the concept of cosine similarity to confidently infer the associations between diseases and genes, miRNAs. The knowledgebase, we developed, will support the researcher around the world to discover the existing knowledge and find a solution for this pandemic.
              </p>
            </Col>
          </Row>
        </div>
      </div>
      <br />
      <div className="container">
        <Row>
          <Col lg={8} xs={24}>
            <Typography.Title level={3}>
              Researchers in Collaboration:
            </Typography.Title>
            <ol>
              <li>Dr. Tanvir Alam</li>
              <li>Dr. Rizwan Qureshi</li>
              <li>Syed Abdullah Basit</li>
              <li>Saleh Musleh</li>
            </ol>
          </Col>
          <Col lg={8} xs={24}>
            <Typography.Title level={3}>Collaborating Institutes:</Typography.Title>
            <ol>
              <li>Information and Computing Technology Division, College of Science and Engineering, Hamad Bin Khalifa University, Doha, Qatar.</li>
              <li>FAST National University of Computer and Emerging Sciences, Karachi, Pakistan.</li>
            </ol>
          </Col>
          <Col lg={8} xs={24}>
            <Typography.Title level={3}>Contact Us:</Typography.Title>
            <ol>
              <li>
                <p>
                  Dr. Tanvir Alam, Information and Computing Technology Division, College of Science and Engineering, Hamad Bin Khalifa University, Doha, Qatar.
                </p>
                <p>
                  Email: <a href="mailto:talam@hbku.edu.qa">talam@hbku.edu.qa</a>
                </p>
              </li>
            </ol>
          </Col>
        </Row>
      </div>
    </>
  )
}